import { Component } from '@angular/core';

@Component({
  selector: 'app-details-item-placeholder',
  templateUrl: './details-item-placeholder.component.html',
  standalone: true,
})
export class DetailsItemPlaceholderComponent {}
